'use client'

// Como GIA solo usa español, este componente no es necesario
// Devolvemos null para no mostrar el selector de idioma

const LanguageDropdown = () => {
  return null
}

export default LanguageDropdown
